import { render, staticRenderFns } from "./NavigationApi.vue?vue&type=template&id=249a4c7e&"
import script from "./NavigationApi.vue?vue&type=script&lang=js&"
export * from "./NavigationApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports